/**
 * A single reserved equipment unit on an equipment-based purchase item. Mirrors the backend
 * App\Document\Order\EquipmentUnit. Name is auto-generated ("Equipment 1", "Equipment 2", ...) and
 * there is no attendee/guest.
 */
export interface EquipmentUnit {
    id: ID;
    name: string;
    checkInStatus: EquipmentUnitStatus;
    unit?: { id: ID };
    resource?: { id: ID };
}

export enum EquipmentUnitStatus {
    PENDING = "pending",
    RESERVED = "reserved",
    PENDING_REMOVAL = "pending_removal",
    PENDING_CANCEL = "pending_cancel",
    PENDING_NO_SHOW = "pending_noshow",
    CANCELED = "canceled",
    CHECKED_OUT = "checked_out",
    RETURNED = "returned",
    NO_SHOW = "noshow",
}
